import EcoSectionCard from 'eco-design/sections/eco-section-card';
import useVideo from '../useVideo';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoTitle from 'eco-design/base/eco-title';
import getLocal from '@/app/utils/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA');
    const { locale } = getLocal();
    const { top, src } = useVideo({
        className: styles.comp,
        url: 'https://websiteoss.ecoflow.com/upload/video/1745222619417/video1.mp4',
        offset: '80%',
        duration: '200%',
    });
    return (
        <>
            <div className={styles.comp} id="sectionC1" style={{ top: `${top}px` }}>
                {locale === 'au' && <EcoTitle title={t('header_title')} />}
                <EcoSectionCard
                    theme="black"
                    layout="center-center"
                    isVideo={true}
                    label={t('label')}
                    title={t('title')}
                    desc={t('desc')}
                    pc={src}
                    autoPlay={false}
                    poster="https://websiteoss.ecoflow.com/upload/image/1744880265179/%E8%A7%86%E9%A2%911.jpg"
                />
            </div>
        </>
    );
}
